import { render, staticRenderFns } from "./Emcd.vue?vue&type=template&id=0b72c6ea&scoped=true&"
import script from "./Emcd.vue?vue&type=script&lang=js&"
export * from "./Emcd.vue?vue&type=script&lang=js&"
import style0 from "./Emcd.vue?vue&type=style&index=0&id=0b72c6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72c6ea",
  null
  
)

export default component.exports